import React from 'react'

import PropTypes from 'prop-types'

import {
  Button,
  TextField,
  Table,
  TableHead,
  TableCell,
  TableRow,
  IconButton,
  TableBody,
  Tooltip,
  TableContainer
} from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import CloseIcon from '@material-ui/icons/Close'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import Autocomplete from '@material-ui/lab/Autocomplete'
import styles from './Receipt.module.css'
import tableStyles from './../../shared/SimpleTable/SimpleTable.module.css'

class ReceiptForm extends React.Component {
  render() {
    console.log(this.props.receiptDetails)
    return(
      <>
        <form>
          <div className={styles.groupTextfield}>
            {
              [null, undefined].includes(this.props.initialReceipt.id) ?
                (
                  <div className={styles.clientAutoCompleteField}>
                    <Autocomplete
                      name="client_id"
                      id="client_id"
                      key="client"
                      size="small"
                      loading={this.props.clientsAutoCompleteLoading}
                      options={(this.props.clients).sort(function (a, b) {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                      })}
                      getOptionLabel={(option) => option.name || ''}
                      getOptionSelected={(option, value) => option.id === value.id}
                      onChange={this.props.handleAutocomplete}
                      onInputChange={(event, value, reason) => this.props.handleAutocompleteOnInputChange(event, value, reason)}
                      fullWidth={true}
                      value={this.props.initialReceipt.client}
                      closeIcon={<CloseIcon fontSize="small" id="clear_client_autocomplete" />}
                      renderInput={(params) => <TextField {...params} label="Client Name" variant="outlined" required />}
                    />
                  </div>
                ) : (
                  <div className={styles.addressBody}>
                    <div>
                      Client Name :
                    </div>
                    <div>
                      { this.props.selectedClient.name }
                    </div>
                  </div>
                )
            }

            <div className={styles.addressBody}>
              <div>
                Address :
              </div>
              <div>
                { this.props.selectedClient.company_address || this.props.selectedClient.home_address || '' }
              </div>
            </div>
          </div>

          <div className={styles.groupTextfield3}>
            <div className={styles.autoCompleteField}>
              <Autocomplete
                name="branch_id"
                id="branch_id"
                key="branch"
                size="small"
                loading={this.props.branchesAutoCompleteLoading}
                options={(this.props.branches).sort(function (a, b) {
                  if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                  if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                  return 0;
                })}
                getOptionLabel={(option) => option.name || ''}
                getOptionSelected={(option, value) => option.name === value.name}
                onChange={this.props.handleAutocomplete}
                onInputChange={(event) => this.props.handleAutocompleteOnInputChange(event)}
                fullWidth={true}
                value={this.props.initialReceipt.branch}
                closeIcon={<CloseIcon fontSize="small" id="clear_branch_autocomplete" />}
                renderInput={(params) => <TextField {...params} label="Branch" variant="outlined" required />}
              />
            </div>
            <div>
            <TextField
              autoComplete="off"
              variant="outlined"
              className={styles.textFields}
              size="small"
              required
              name="reference_no"
              id="reference_no"
              fullWidth={true}
              label="Collection Receipt Number"
              value={this.props.initialReceipt.reference_no}
              onChange={this.props.handleReceiptFormInputChange}
              InputLabelProps={{
                shrink: this.props.initialReceipt.reference_no !== undefined && Object.entries(this.props.initialReceipt.reference_no).length > 0,
              }}
            />
            <div className={styles.error}>{
              this.props.error ? 
                this.props.error.reference_no?'Collection Receipt Number ' + this.props.error.reference_no:null
                : null
              }
            </div>
            </div>
            <div>
            <TextField
              autoComplete="off"
              className={styles.textFields}
              type="date"
              variant="outlined"
              size="small"
              required
              name="date_of_receipt"
              fullWidth={true}
              label="Date of Receipt"
              onChange={this.props.handleReceiptFormInputChange}
              value={this.props.initialReceipt.date_of_receipt}
              id="date_of_receipt"
              InputLabelProps={{
                shrink: true
              }}
            />
            </div>
            <div>
              <TextField
                autoComplete="off"
                className={styles.textFields}
                variant="outlined"
                size="small"
                name="project_name"
                fullWidth="true"
                label="Project Name"
                onChange={this.props.handleReceiptFormInputChange}
                value={this.props.initialReceipt.project_name || ''}
                id="project_name"
              />
            </div>
          </div>

          <div>
            {
              this.props.invoiceThru === true || [null, undefined].includes(this.props.initialReceipt.id) ?
              (
                <>
                  <div className={styles.headerContent}>
                    <div> Receipts/Collections Details </div>

                    <Tooltip title="Add" arrow>
                      <IconButton
                        variant="addAddress"
                        name="add_receipt_details"
                        disabled={Object.keys(this.props.selectedClient).length === 0}
                        onClick={() => this.props.handleOpenSimplePopup({}, true)}>
                        <AddCircleOutlineIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </div>

                  {
                    this.props.receiptDetails.length > 0 ? (
                      <TableContainer className="action-button" style={{maxHeight: '575px', position: 'relative'}}>
                        <Table name='receipt_details_table'>
                          <TableHead>
                            <TableRow>
                              <TableCell>
                                <b>Invoice Reference No</b>
                              </TableCell>
                              <TableCell>
                                <b>Bank</b>
                              </TableCell>
                              <TableCell>
                                <b>Terms of Payment</b>
                              </TableCell>
                              <TableCell>
                                <b>Amount</b>
                              </TableCell>
                              <TableCell>
                                <b>Remarks</b>
                              </TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody className={tableStyles.tableBody}>
                            {
                              this.props.receiptDetails.map((item, index) => (
                                <>
                                  <TableRow key={index}>
                                    <TableCell>
                                      { item.invoice.reference_no }
                                    </TableCell>

                                    <TableCell>
                                      { item.bank? item.bank.name: '' }
                                    </TableCell>

                                    <TableCell>
                                      { item.payment_term? item.payment_term.name: '' }
                                    </TableCell>

                                    <TableCell>
                                      { parseFloat(item.amount).toLocaleString(navigator.language, {minimumFractionDigits: 2}) }
                                    </TableCell>

                                    <TableCell>
                                      { item.remarks }
                                    </TableCell>

                                    <TableCell size="small" className={styles.actionButtonHoverable} align="right">
                                      <Tooltip title="Edit" arrow>
                                        <IconButton
                                          size="small"
                                          id="edit_receipt_detail"
                                          name="edit_receipt_detail"
                                          color="primary"
                                          onClick={() => this.props.handleOpenSimplePopup(item, false, index)}>
                                          <EditIcon/>
                                        </IconButton>
                                      </Tooltip>

                                      <Tooltip title="Delete" arrow>
                                        <IconButton
                                          id="delete_receipt_detail"
                                          name="delete_receipt_detail"
                                          size="small"
                                          color="secondary"
                                          onClick={() => this.props.handleDeleteReceiptDetails(index)}
                                        >
                                          <DeleteIcon/>
                                        </IconButton>
                                      </Tooltip>
                                    </TableCell>
                                  </TableRow>
                                </>
                              ))
                            }
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ) : (null)
                  }
                </>
              ) : (null)
            }

            <div className={styles.actionButton}>
              <Button variant="outlined" id="receipt_submit" disabled={Object.keys(this.props.selectedClient).length === 0 || !this.props.receiptDetails.length > 0} color="primary" onClick={this.props.handleSaveReceipt}>Save</Button>
            </div>
          </div>
        </form>
      </>
    )
  }
}

export default ReceiptForm

ReceiptForm.propTypes = {
  branches: PropTypes.array,
  termsOfPayments: PropTypes.array,
  clients: PropTypes.array,
  clientsAutoCompleteLoading: PropTypes.bool,
  invoiceThru: PropTypes.bool,
  branchesAutoCompleteLoading: PropTypes.bool,
  termsOfPaymentsAutoCompleteLoading: PropTypes.bool,
  selectedClient: PropTypes.object,
  initialReceipt: PropTypes.object,
  initialReceiptDetail: PropTypes.object,
  error: PropTypes.object,
  handleAutocomplete: PropTypes.func,
  handleAutocompleteOnInputChange: PropTypes.func,
  handleReceiptFormInputChange: PropTypes.func,
  receiptDetails: PropTypes.array,
  handleOpenSimplePopup: PropTypes.func,
  handleSwitch: PropTypes.func,
  handleDeleteReceiptDetails: PropTypes.func,
  handleSaveReceipt: PropTypes.func
}
